<!--P119-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">日志管理</div>
    </div>
    <!--查询栏-->
    <div class="cs_margin_top div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">日期</div>
      <input v-model="search.startDate" id="startDate" class="cs_input cs_radius_lg edtxt_info_search width_216" placeholder="请输入" readonly>
      <div class="cs_title_primary cs_text_default type_info_search margin_left_12">~</div>
      <input v-model="search.endDate" id="endDate" class="cs_input cs_radius_lg edtxt_info_search margin_left_12 width_216" placeholder="请输入" readonly>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">制单人</div>
      <web-select :options="search.staffList"
                  @option-key="updateStaff"
                  v-model="search.staffName"
                  class="cs_input cs_radius_lg edtxt_info_search"></web-select>
      <button class="ui_btn_search_yellow btn_search" type="button" @click="btnSearch">查询</button>
    </div>
    <!--表格-->
    <div class="cs_margin_top div_search_result cs_padding_top_lg">
      <div class="div_table">
        <table class="cs_table cs_td_divider_none" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="170px">模块</th>
            <th width="487px">操作</th>
            <th width="80px">操作员</th>
            <th width="160px">时间</th>
            <th width="142px">IP地址</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList">
            <td>{{index+1}}</td>
            <td>{{item.moduleName}}</td>
            <td>{{item.operationDetail}}</td>
            <td>{{item.operationName}}</td>
            <td>{{item.cstCreate}}</td>
            <td>{{item.clientIp}}</td>
          </tr>
          <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
            <td v-for="j in 6"></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="div_page_download">
        <!--上一页-->
        <button v-show="search.pagination>1" @click="showList(search.pagination < 2?1:search.pagination-1)"
                class="btn_page_up" type="button">
        </button>
        <button v-show="search.pagination<=1" class="btn_page_up_disable" type="button"></button>
        <div class="current_page">{{search.pagination}}</div>
        <div class="oblique_line">/</div>
        <div class="total_page">{{search.totalPage}}</div>
        <!--下一页-->
        <button v-show="search.pagination!==search.totalPage" @click="showList(search.pagination+1)" class="btn_page_down" type="button"></button>
        <button v-show="search.pagination===search.totalPage" class="btn_page_down_disable" type="button"></button>
        <div @click="jump()" class="type_page_jump">跳转至</div>
        <input v-model="search.pageJump" class="txt_page_jump" type="text"
               @keyup="checkPositiveInt($event)" @blur="search.pageJump=checkPositiveInt($event)">
      </div>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select";
  import {Page, PAGE_SIZE} from "../../assets/utils/constants"
  import StorageConst from "../../assets/utils/StorageConst";
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  export default {
    name: "LogManage",
    components: {SearchSelect, WebSelect},
    data: function () {
      return {
        search: {
          startDate: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.LOG_MANAGE,"startDate", this.getPreNDays(7)),
          endDate: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.LOG_MANAGE,"endDate", this.getNowDate()),
          staffList: [],
          staffId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.LOG_MANAGE,"staffId", 0),
          staffName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.LOG_MANAGE,"staffName", ""),
          pageJump: "",
          totalPage: "",
          pagination: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.LOG_MANAGE,"pagination", 1)
        },
        orderList: [],
        PAGE_SIZE: PAGE_SIZE,
      }
    },
    created: function () {
      this.showStaff();
      this.showList(this.search.pagination);
    },
    mounted: function () {
      const that = this;
      laydate.render({
        elem: '#startDate',
        btns:["now","confirm"],
        done(value) {
          that.search.startDate = value;
        },
      });
      laydate.render({
        elem: '#endDate',
        btns:["now","confirm"],
        done(value) {
          that.search.endDate = value;
        },
      });
    },
    methods:{
      showList(pagination) {
        try {
          let next3Date = this.getNextNMonthDate(this.search.startDate,12);
          WhParameter.verifyStartEndDate(this.search.startDate, "起始日期",this.search.endDate,"截止日期");
          WhParameter.verifyStartEndDate(this.search.endDate, "日期间隔",next3Date,"一年");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        this.$ajax.log.pageByFuzzy.bind(this)(this.search, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.search.totalPage = data.data.totalPage;
          this.search.pagination = data.data.pagination;
          this.orderList = data.data.list;
          this.setStoreItem(StorageConst.LOCAL_PAGE_LIST.LOG_MANAGE, JSON.stringify(this.search));
        }, (data) => {
        }, true)
      },
      btnSearch(){
        this.showList(1);
      },
      jump() {
        if (!this.isEmpty(this.search.pageJump)) {
          if(this.search.pageJump>this.search.totalPage){
            this.showList(this.search.totalPage);
          }else {
            this.showList(this.search.pageJump);
          }
        }
      },
      failDefault() {

      },
      showStaff(){
        this.$ajax.common.listStaff.bind(this)((data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].name,
            })
          }
          this.search.staffList = array;
        }, (data) => {
        }, true)
      },
      updateStaff(key) {
        this.search.staffId = key;
      },
    }
  }
</script>

<style scoped>
  .width_216{width: 216px;}
  .margin_left_12{margin-left: 12px;}
</style>



// WEBPACK FOOTER //
// src/page/log/LogManage.vue